import React from 'react';
import styled, { keyframes } from 'styled-components';
import useUser from 'state/user';
import { useMemo } from 'react';
import PatientList from './PatientList';
import { DARK_TEXT } from 'resources/constants/colors';

const fadeUp = keyframes`
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
`;

const Section = styled.div`
    animation: ${fadeUp} 0.35s 0.1s ease both;
`;

const SectionLabel = styled.p`
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    color: #aaa;
    margin: 0 0 8px;
    padding: 0 2px;
`;

const Card = styled.div`
    background: #fff;
    border-radius: 16px;
    padding: 12px 16px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.06);
`;

const EmptyState = styled.div`
    text-align: center;
    padding: 16px 10px;
`;

const EmptyText = styled.p`
    font-size: 14px;
    color: ${DARK_TEXT};
    margin: 4px 0 0;
`;

const PatientListSection = () => {
    const [user] = useUser();

    // Filtrar entradas sin id o name (usuarios eliminados que puedan venir en caché)
    const clientsList = useMemo(() => {
        const raw = Array.isArray(user.current.extraData?.clients) ? user.current.extraData.clients : [];
        return raw.filter(c => c && c.id && c.name);
    }, [user]);

    return (
        <Section>
            <SectionLabel>Pacientes</SectionLabel>
            <Card>
                {clientsList.length === 0 ? (
                    <EmptyState>
                        <span style={{ fontSize: 28 }}>👤</span>
                        <EmptyText>Cuando tengas pacientes asignados, aparecerán aquí.</EmptyText>
                    </EmptyState>
                ) : (
                    <PatientList list={clientsList} />
                )}
            </Card>
        </Section>
    );
};

export default PatientListSection;
